// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.connection-status-table {
  font-size: var(--font-size-s);
  table-layout: fixed;
}

.connection-status-table td {
  width: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/session-view/side-panels/right-side-panel/participant-list/participant-list-item/connection-status/ConnectionStatus.component.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".connection-status-table {\n  font-size: var(--font-size-s);\n  table-layout: fixed;\n}\n\n.connection-status-table td {\n  width: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
